<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "commondescr",
      key: "id",
      url: {},
      id: "",
      typeId: "",
      items: [
        { label: "填写会议记录", type: "header" },
        {
          label: "记录人",
          name: "recordUserId",
          value: "",
          type: "select",
          width: "400px",
          dropList: [],
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
        {
          label: "文件",
          name: "recordFile",
          value: "",
          type: "documents",
          desc: "",
          handleRemove: this.handleRemove,
        },
        { label: "详情", name: "content", value: "", type: "editor" },
      ],
      forms: {},
    };
  },
  created() {
    let query = this.$route.query;
    console.log(query.id);
    if (query) {
      this.meetingId = query.id;
    }
    this.loaduserData1();
  },
  methods: {
    loaduserData1() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/user/listAll", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.nickName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "recordUserId") {
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    handleSubmit() {
      let q = this.forms;
      q.meetingId = this.meetingId;
      this.$refs.form.validate((valid) => {
        this.sloading = true;
        $utils.api
          .load(`/admin/system/meeting/record`, q, "POST")
          .then((res) => {
            this.sloading = false;
            if (res.status) {
              $utils.toast.success("保存成功");
              $utils.url.go(-1);
            }
          })
          .catch((e) => {
            this.sloading = false;
            $utils.toast.error("保存异常" + e.message);
          });
      });
    },
  },
};
</script>
